import { buildLumiNextUrl } from './build-lumi-next-url';
import { isProduction } from './env-define';

/**
 * Whether the app should hand authenticated users off to lumi-next
 * (account.lumi-app.co). Only true in production builds.
 */
export const shouldHandOffToLumiNext = (): boolean => isProduction();

type TRedirectToLumiNextParams = {
  pathname: string;
  userId?: string | null;
};

/**
 * Performs a full-document redirect to the corresponding lumi-next page,
 * forwarding the user id for auto-login. lumi-next resolves the locale itself
 * (next-intl middleware + Accept-Language detection), so no locale is sent.
 *
 * Returns a never-resolving promise so callers (TanStack Router `beforeLoad`)
 * stay pending while the browser unloads the current document — this prevents
 * the legacy app's UI from flashing before the redirect takes effect.
 */
export const redirectToLumiNext = ({ pathname, userId }: TRedirectToLumiNextParams): Promise<never> => {
  window.location.replace(buildLumiNextUrl({ pathname, userId }));

  return new Promise<never>(() => {});
};
